import React, {Component} from 'react'

export default class Redirect extends Component {
    componentDidMount() {
        const {match: {params: {to}}} = this.props;

        if (window.opener) {
            window.opener.location = to ? decodeURIComponent(to) : process.env.PUBLIC_URL + '/fake-login';
        }
    }

    render() {
        return <h1>You should return to the tab whose link you clicked on to get here. :)</h1>
    }
}